<template>
	<router-view></router-view>
	<teleport to="body">
    <!-- <transition name="fade">
      <div v-if="state.showModal" class="modal" tabindex="-1" role="dialog" @click="hideModal()">
        <div class="modal-dialog modal-lg" role="document" @click.stop>
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ state.selectedModal.title }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="hideModal()">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p v-html="state.selectedModal.text"></p>
            </div>
            <div class="modal-footer">
              <button class="btn btn-secondary" data-dismiss="modal" @click="hideModal()">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition> -->
  </teleport>
</template>